<h3 *ngIf="data == null" mat-dialog-title>Cadastrar Característica do COE</h3>
<h3 *ngIf="data != null" mat-dialog-title>Alterar Característica do COE</h3>
<div mat-dialog-content>

    <div fxLayout="row wrap">
        <div fxFlex.gt-sm="100%">
            <mat-form-field 
                style="width: 100%" 
                appearance="outline" 
                fxFlex="100" 
                floatLabel="always"
            >
                <mat-label>Código CETIP</mat-label>
                <input 
                    matInput 
                    placeholder="Código CETIP" 
                    [formControl]="codigo_cetip"
                    maxlength="255">
            </mat-form-field>
        </div>
    </div>

    <div fxLayout="row wrap">
        <div fxFlex.gt-sm="100%">
            <mat-form-field 
                style="width: 100%" 
                appearance="outline" 
                fxFlex="100" 
                floatLabel="always"
            >
                <mat-label>Código Papel</mat-label>
                <input 
                    matInput 
                    placeholder="Código Papel" 
                    [formControl]="codigo" 
                    maxlength="255">
            </mat-form-field>
        </div>
    </div>

    <div fxLayout="row wrap">
        <div fxFlex.gt-sm="100%">
            <mat-form-field 
                style="width: 100%" 
                appearance="outline" 
                fxFlex="100" 
                floatLabel="always"
            >
                <mat-label>Nome</mat-label>
                <input 
                    matInput 
                    placeholder="Nome" 
                    [formControl]="nome" 
                    required
                    maxlength="255">
                <mat-error *ngIf="nome.invalid">{{getErrorNameMessage()}}</mat-error>
            </mat-form-field>
        </div>
    </div>

    <div fxLayout="row wrap">
        <div fxFlex.gt-sm="100%">
            <mat-form-field 
                style="width: 100%" 
                appearance="outline" 
                fxFlex="100" 
                floatLabel="always"
            >
                <mat-label>Rentabilidade Atual</mat-label>
                <input 
                    matInput 
                    placeholder="Rentabilidade Atual" 
                    [formControl]="rent_atual" 
                    required
                    maxlength="10"
                    currencyMask 
                    [options]="{  suffix: ' %', prefix: ' ', thousands: '.', decimal: ',' }">                
            </mat-form-field>
        </div>
    </div>

    <div fxLayout="row wrap">
        <div fxFlex.gt-sm="100%">
            <mat-form-field 
                style="width: 100%" 
                appearance="outline" 
                fxFlex="100" 
                floatLabel="always"
            >
                <mat-label>% CDI</mat-label>
                <input 
                    matInput 
                    placeholder="% CDI" 
                    [formControl]="cdi" 
                    required
                    maxlength="15"
                    currencyMask 
                    [options]="{  suffix: ' %', prefix: ' ', thousands: '.', decimal: ',' }">                
            </mat-form-field>
        </div>
    </div>

    
    <div fxLayout="column" fxLayoutAlign="start" fxLayout.gt-md="row">
        <mat-form-field appearance="outline" floatLabel="always" style="width: 100%" fxFlex="100">
            <mat-label>Estrutura</mat-label>
            <mat-select             
                [(value)]="model.estrutura_id"
                [formControl]="estrutura_id">
                <mat-option value="">SELECIONE</mat-option>
                <mat-option *ngFor="let estrutura of listEstrutura"
                    [value]="estrutura.id">{{estrutura.nome}}</mat-option>
            </mat-select>
            <mat-spinner diameter="20" *ngIf="loadingSpinnerEstrutura"></mat-spinner> 
        </mat-form-field>
    </div>

    <div fxLayout="row wrap">
        <div fxFlex.gt-sm="100%">
            <mat-form-field appearance="outline" floatLabel="always" fxFlex="100">
                <mat-label>Data da Início Reserva</mat-label>
                <input 
                    matInput 
                    [matDatepicker]="picker" 
                    [formControl]="data_inicio" 
                    name="data_inicio" 
                    placeholder="Data da Início">
                <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                <mat-datepicker #picker></mat-datepicker>
            </mat-form-field> 
        </div>        
    </div>

    <div fxLayout="row wrap">
        <div fxFlex.gt-sm="100%">    
            <mat-form-field appearance="outline" floatLabel="always" fxFlex="100">
                <mat-label>Data de Fim da Reserva</mat-label>
                <input 
                    matInput 
                    [matDatepicker]="picker2" 
                    [formControl]="data_fim" 
                    name="data_fim" 
                    placeholder="Data de Vencimento">
                <mat-datepicker-toggle matSuffix [for]="picker2"></mat-datepicker-toggle>
                <mat-datepicker #picker2></mat-datepicker>
            </mat-form-field> 
        </div>        
    </div>

    <div fxLayout="row" fxLayoutAlign="space-between">
        <mat-form-field style="width: 100%" floatLabel="always" fxFlex="100" appearance="outline" >
            <mat-label>ROA</mat-label>
            <input 
                matInput 
                placeholder="ROA" 
                [formControl]="vlr_roa"
                currencyMask 
                required
                maxlength = "9" 
                [options]="{  suffix: ' %', prefix: ' ', thousands: '.', decimal: ',' }"> 
        </mat-form-field>
    </div>

    <div fxLayout="row" fxLayoutAlign="space-between">
        <mat-form-field style="width: 100%" floatLabel="always" fxFlex="100" appearance="outline" >
            <mat-label>Adicionar Data de Observação</mat-label>
            <input 
                matInput 
                [matDatepicker]="picker3" 
                [formControl]="dataObj" 
                name="dataObj" 
                placeholder="Data de Observação">
            <mat-datepicker-toggle matSuffix [for]="picker3"></mat-datepicker-toggle>
            <mat-datepicker #picker3></mat-datepicker>
        </mat-form-field>
        <button style="margin-top:15px" type="button" aria-label="Adicionar Data" mat-icon-button (click)="addDataObservacao()">
            <mat-icon>add_circle</mat-icon>
        </button>
    </div>
    <div fxLayout="row" fxLayoutAlign="space-between">
        <div>
            <ul>
                <li style="list-style: none;" *ngFor="let item of model.datas_observacao">
                    {{item.data | date:'dd/MM/yyyy'}}
                    <button mat-icon-button color="warn" matTooltip="Excluir Data de Observação" (click)="deleteDataObservacao(item)">
                        <mat-icon aria-label="Excluir Data de Observação">delete</mat-icon>
                    </button>
                </li>
            </ul>
        </div>
    </div>
</div>
<div mat-dialog-actions>
    <button mat-button tabindex="2" (click)="onNoClick()">Cancelar</button>
    <button mat-button [disabled]="isInvalidForm()" (click)="salvar()" tabindex="-1">Salvar</button>
</div>